import { render, staticRenderFns } from "./SectionCardsTitleAndIcon.vue?vue&type=template&id=ca6f6d62&scoped=true&"
import script from "./SectionCardsTitleAndIcon.vue?vue&type=script&lang=ts&"
export * from "./SectionCardsTitleAndIcon.vue?vue&type=script&lang=ts&"
import style0 from "./SectionCardsTitleAndIcon.vue?vue&type=style&index=0&id=ca6f6d62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6f6d62",
  null
  
)

export default component.exports